<script>
    import title from '.././constantes.js'
    import Carousel from 'svelte-carousel'
</script>

<Carousel autoplay autoplayDuration={5000} let:loaded arrows={false} dots={true}>
  <div class="img-container">
    <img src="./images/carousel/Clinica1.jpg" width="100%" alt="Imagen de {title}">
  </div>
  <div class="img-container">
    <img src="./images/carousel/Clinica2.jpg" width="100%" alt="Imagen de {title}">
  </div>
  <div class="img-container">
      <img src="./images/carousel/Clinica3.jpg" width="100%" alt="Imagen de {title}">
  </div>
</Carousel>